import DisplayClientError from "../../../../local/shared/DisplayClientError.js";
import * as React from 'react';
export default {
  DisplayClientError,
  React
};